<footer class="footer">
    <div class="footer-container">
        <div class="footer-grid">
            <div class="footer-brand">
                <div class="logo">
                    <img [src]="logoSrc()" alt="Alta Sistemas" class="logo-image">
                </div>
                <p class="tagline">Transformando ideias em soluções digitais de alto impacto.</p>
            </div>

            <div class="footer-links">
                <h4>Navegação</h4>
                <nav>
                    <a href="#servicos" (click)="scrollToSection($event, 'servicos')">Serviços</a>
                    <a href="#processo" (click)="scrollToSection($event, 'processo')">Processo</a>
                    <a href="#duvidas" (click)="scrollToSection($event, 'duvidas')">Dúvidas</a>
                    <a routerLink="/contato">Fale Conosco</a>
                </nav>
            </div>

            <div class="footer-links">
                <h4>Serviços</h4>
                <nav>
                    <a href="#servicos" (click)="scrollToSection($event, 'servicos')">Desenvolvimento Web</a>
                    <a href="#servicos" (click)="scrollToSection($event, 'servicos')">Desenvolvimento Mobile (Ionic)</a>
                    <a href="#servicos" (click)="scrollToSection($event, 'servicos')">APIs & Integrações</a>
                </nav>
            </div>

            <div class="footer-contact">
                <h4>Contato</h4>
                <div class="contact-info">
                    <a href="mailto:contato@altasistemas.com.br">contato&#64;altasistemas.com.br</a>
                    <a href="https://wa.me/556492097848" target="_blank" rel="noopener noreferrer">+55 64 9209-7848</a>
                    <p>Goiânia, GO</p>
                    <p>Seg-Sex: 9h às 18h</p>
                </div>
            </div>
        </div>

        <div class="footer-bottom">
            <p>&copy; {{ currentYear }} Alta Sistemas. Todos os direitos reservados.</p>
            <a routerLink="/politica-de-privacidade">Política de Privacidade</a>
        </div>
    </div>
</footer>